import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetProductsFromOc } from '../../services/ProductsService';
import { contactBackBff } from '../../../src/config/paths';

export const getProducts = createAsyncThunk(
  'products/getProducts',
  async (params) => {
    const { oc, reCaptchaToken } = params;
    const response = await callGetProductsFromOc(
      oc,
      reCaptchaToken,
      contactBackBff,
    );
    return response.data;
  },
);
